import React, { useState, useEffect } from 'react';
import styled from 'styled-components';

const SuggestionsCard = styled.div`
  background: transparent;
  border: none;
  padding: 4px 0;
  margin-top: 10px;
  margin-bottom: 4px;
  direction: rtl;
  text-align: right;
`;

const ExplanationText = styled.div`
  color: #64748b;
  font-size: 13px;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  gap: 8px;
  direction: rtl;
  text-align: right;
`;

const Label = styled.div`
  font-size: 12.5px;
  font-weight: 800;
  color: #006200;
  margin-bottom: 9px;
  direction: rtl;
  text-align: right;
`;

const SuggestionButtons = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  direction: rtl;
  justify-content: flex-start;
`;

// Elegant, on-brand pills (match the goal-brief / showcase chips), not heavy gradient buttons.
const SuggestionButton = styled.button`
  background: rgba(27,140,60, 0.07);
  color: #006200;
  border: 1px solid rgba(27,140,60, 0.3);
  padding: 8px 15px;
  border-radius: 999px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: transform 0.15s, background 0.15s, border-color 0.15s;
  direction: rtl;
  text-align: center;

  &:hover {
    transform: translateY(-1px);
    background: rgba(27,140,60, 0.13);
    border-color: rgba(27,140,60, 0.55);
  }

  &:active {
    transform: translateY(0);
  }
`;

const FirstTimeInfo = styled.div`
  background: linear-gradient(135deg, #FFF7ED 0%, #FFEDD5 100%);
  border: 2px solid #FED7AA;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 16px;
  position: relative;
`;

const FirstTimeTitle = styled.div`
  color: #9A3412;
  font-size: 15px;
  font-weight: 600;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  gap: 8px;
`;

const FirstTimeText = styled.div`
  color: #9A3412;
  font-size: 14px;
  line-height: 1.5;
  margin-bottom: 12px;
`;

const DismissButton = styled.button`
  background: #F97316;
  color: white;
  border: none;
  padding: 6px 12px;
  border-radius: 4px;
  font-size: 12px;
  cursor: pointer;
  font-weight: 600;
  transition: background 0.2s;

  &:hover {
    background: #EA580C;
  }
`;

function ContextualSuggestions({ suggestions, explanation, onSuggestionClick, label = '🔍 إجراءات سريعة:' }) {
  const [showFirstTimeInfo, setShowFirstTimeInfo] = useState(false);

  useEffect(() => {
    // Check if user has seen the explanation before
    const hasSeenExplanation = localStorage.getItem('hasSeenContextualSuggestionsExplanation');
    if (!hasSeenExplanation) {
      setShowFirstTimeInfo(true);
    }
  }, []);

  const handleDismiss = () => {
    localStorage.setItem('hasSeenContextualSuggestionsExplanation', 'true');
    setShowFirstTimeInfo(false);
  };

  // Show suggestions even if array is empty - they might be helpful fallbacks
  const hasSuggestions = suggestions && suggestions.length > 0;

  // Don't render if no explanation and no suggestions
  if (!explanation && !hasSuggestions) {
    return null;
  }

  return (
    <SuggestionsCard>
      {/* Explanation of what was shown */}
      {explanation && (
        <ExplanationText>
          ℹ️ {explanation}
        </ExplanationText>
      )}

      {/* Clickable suggestions */}
      {hasSuggestions && (
        <div>
          <Label>{label}</Label>
          <SuggestionButtons>
            {suggestions.map((suggestion, i) => (
              <SuggestionButton
                key={i}
                onClick={() => onSuggestionClick(suggestion.query)}
              >
                {suggestion.label}
              </SuggestionButton>
            ))}
          </SuggestionButtons>
        </div>
      )}
    </SuggestionsCard>
  );
}

export default ContextualSuggestions;
